module.exports = __webpack_public_path__ + "img/collectHead.662fab3b.png";